import { securePut } from 'config/apiConfig';

const validateCart = async (id, cart) => {
  const { data } = await securePut(`/carts/validate/${id}`, cart);
  return data;
};

export default validateCart;
